
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Bei chronischen Spannungskopfschmerzen, also an mindestens 15 Tagen pro Monat,
kann diese Methode einen Versuch wert sein. Einer Übersichtsarbeit aus dem Jahr
2016 zufolge halbiert sich die Häufigkeit der Schmerzanfälle bei 52 von 100
Betroffenen – wobei Scheinakupunktur immerhin 43 von 100 Personen hilft. Dabei
werden absichtlich falsche Stellen am Körper genadelt oder die Nadel durchdringt
die Haut nicht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;